import React from "react";
import { Link } from "react-router-dom";

export default function Navbar(props) {
     return (
          <nav
               className="navbar navbar-expand-lg bg-body-tertiary "
               data-bs-theme={`${props.darkMode}`}
          >
               <div className="container-fluid">
                    <Link className="navbar-brand" to="/">
                         TextUtils
                    </Link>
                    <button
                         className="navbar-toggler"
                         type="button"
                         data-bs-toggle="collapse"
                         data-bs-target="#navbarText"
                         aria-controls="navbarText"
                         aria-expanded="false"
                         aria-label="Toggle navigation"
                    >
                         <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarText">
                         <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                              <li className="nav-item">
                                   <Link
                                        className="nav-link active"
                                        aria-current="page"
                                        to="/"
                                   >
                                        Home
                                   </Link>
                              </li>
                              <li className="nav-item">
                                   <Link className="nav-link" to="/about">
                                        About
                                   </Link>
                              </li>
                         </ul>
                         <span className="navbar-text">
                              <div className="form-check form-switch" onClick={props.handleDarkMode}>
                                   <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchCheckDefault"
                                   />
                              </div>
                         </span>
                    </div>
               </div>
          </nav>
     );
}
